import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      /* `relative` matters: the Moon is absolutely positioned and needs this as
         its containing block, otherwise it anchors to the nearest positioned
         ancestor (the header) and drifts. */
      className="relative h-9 w-9 rounded-md text-muted-foreground transition-colors duration-180 ease-premium hover:bg-muted hover:text-foreground"
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      aria-label="Toggle theme"
    >
      <Sun className="h-4 w-4 rotate-0 scale-100 transition-transform duration-220 ease-premium dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-transform duration-220 ease-premium dark:rotate-0 dark:scale-100" />
    </Button>
  );
}
